import { Alert, Button, Spin } from "@arco-design/web-react";
import { ArrowLeft, RefreshCw } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";

import { isHttpClientError } from "../../../lib/http/errors";
import { useItineraryEntryRedirect } from "..";

/** 从 customization demand 幂等进入原生行程编辑器。 */
export function ItineraryEntryRedirectPage() {
  const { demandId = "" } = useParams();
  const navigate = useNavigate();
  const runtime = useItineraryEntryRedirect(demandId);
  const errorView = itineraryEntryErrorView(runtime.error);
  return (
    <main className="itinerary-editor-loading">
      {runtime.error ? (
        <>
          <div role="alert"><Alert type="error" content={errorView.message} /></div>
          <div className="itinerary-editor-empty-actions">
            <Button icon={<ArrowLeft size={16} />} onClick={() => navigate("/crm/customization/projects", { replace: true })}>
              返回定制项目
            </Button>
            {errorView.canRetry ? (
              <Button type="primary" icon={<RefreshCw size={16} />} onClick={() => void runtime.retry()}>
                重试
              </Button>
            ) : null}
          </div>
        </>
      ) : (
        <>
          <Spin size={32} loading={runtime.loading} />
          <span>正在进入行程编辑器...</span>
        </>
      )}
    </main>
  );
}

/** 将需求入口错误区分为终态链接与可恢复故障。 */
function itineraryEntryErrorView(error: unknown): { message: string; canRetry: boolean } {
  if (isHttpClientError(error)) {
    if (error.statusCode === 404 || error.code === "ITINERARY_DEMAND_NOT_FOUND") {
      return {
        message: "未找到该定制需求，可能已删除或链接无效。",
        canRetry: false,
      };
    }
    if (error.statusCode === 403) {
      return { message: "当前账号无权从该需求创建或编辑行程。", canRetry: false };
    }
  }
  return { message: "暂时无法进入行程编辑器，请检查网络后重试。", canRetry: true };
}
